import { useEffect, useState, FC } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ConfigureTablesForm from '../dataExtractorForm/dataExtractorForm'
import Chip from '@mui/material/Chip';
import { useLocation } from 'react-router-dom';
import * as actions from '../../../store/extractor/metaData/action'
import * as dbExtractor from '../../../store/extractor/actions'
import * as profileData from "../../../store/auth/selectors";
import * as user from "../../../store/dataSource/selectors";
import { useSelector, useDispatch } from "react-redux";
import { IDataSourceFields } from '../../organisms/dataSourceForm/index'
import ErrorIcon from '@mui/icons-material/Error';
import { IUser } from '../../../store/groups/types';
import { IEntities } from '../../../store/extractor/types'
import * as jobScheduleTrigger from '../../../store/jobSchedules/action'
import * as eventBasedTrigger from '../../../store/events/actions'
import * as eventTasks from '../../../store/eventBasedTrigger/actions'
import * as webhookAction from '../../../store/webhooks/actions'
import { postDBExtSelector, postCustExtSelector } from "../../../store/extractor/selectors";
import { IPostTaskParams, ITaskListParams, ITaskConnectionParams } from '../../../store/eventBasedTrigger/types'
import { getTaskListSelector, postTaskSelector, getTaskConnectionSelector } from "../../../store/eventBasedTrigger/selectors";
import * as constants from '../../../constants/_pickerValues';
import format from 'date-fns/format';

interface LocationState {
    selectedTables: [],
    selectedSchema: [],
    dataSourceData: IDataSourceFields,
    accessControlGroup: string[],
    dataStewardGroup: string,
    dataStewardIDs: IUser[],
    connection: string,
    endpoint: string,
    winShareName: string,
    winSharePath: string,
    dataSourceName: string,
    customSQL?: boolean,
    spokeName?: string
}

interface Props {
    mode?: string;
}



const CreateExtractorComponent: FC<Props> = ({ mode = constants.MODE.add }: Props) => {

    // window.scrollTo(0, 0)
    const dispatch = useDispatch();
    const [triggerCount, setTriggerCount] = useState(0)
    const [actionCount, setActionCount] = useState(0)
    const [tableDataIndex, setTableDataIndex] = useState<number>()
    const userData = useSelector(user.postDataSelector)
    const sourceID = userData !== null ? userData?.sourceId : 0
    const profile = useSelector(profileData.getProfileDataSelector)
    const email: string = profile !== null ? profile?.mail : 'Could not load email'
    const location = useLocation();
    const [triggerList, setTriggerList] = useState<[]>([])
    const getTaskConnection = useSelector(getTaskConnectionSelector)
    const [taskConnection, setTaskConnection] = useState<any>()
    const [actionList, setActionList] = useState<[]>([])
    const [inboundWebhookList, setInboundWebhookList] = useState<[]>([])
    const [eventList, setEventList] = useState<[]>([])
    const [loaderList, setLoaderList] = useState<[]>([])
    const dbBatchCode = useSelector(postDBExtSelector)
    const [executeTriggers, setExecuteTriggers] = useState<string | null>('')
    const batchCode = useSelector(postCustExtSelector)
    const { selectedTables, selectedSchema, dataSourceData, accessControlGroup, dataStewardGroup, dataStewardIDs, connection, endpoint, dataSourceName, customSQL, spokeName } = location.state as LocationState;
    const [database, setDatabase] = useState('')
    const [taskValue, setTaskValue] = useState<any>();
    const [taskId, setTaskId] = useState<any>();
    const taskList = useSelector(getTaskListSelector);
    const getTaskId = useSelector(postTaskSelector)
    const [layerName, setLayerName] = useState('')
    const [entityName, setEntityName] = useState('')
    const [extractorDescription, setExtractorDescription] = useState('')
    const slash = "/"
    const [errorList, setErrorList] = useState<any>();
    

    // resetting triggers and actions and batchcode on page load to remove old data
    useEffect(() => {
        if (dbBatchCode && dbBatchCode.length > 0) {
            setExecuteTriggers(null)
            dispatch(dbExtractor.postDBExtReset());
        }
        if (batchCode && batchCode.length > 0) {
            dispatch(dbExtractor.postCustomExtReset());
        }
    }, []);



    useEffect(() => {
        if (mode === constants.MODE.add) {
            setTaskId(taskList)
        }
    }, [taskList]);


    // ***********************   STEP 4 - Get Batch Code, Task ID and execute triggers and actions ********************************

    // 4.1 - This runs after custom extractor executed

    // Step 1: fetch task connection and check if task ID already exists
    useEffect(() => {
        if (batchCode && batchCode.length > 0 && mode === constants.MODE.add) {
            const layerNameParams: ITaskConnectionParams = { layerName: layerName }
            dispatch(eventTasks.fetchTaskConnectionReq(layerNameParams));
        }
    }, [batchCode]);

    useEffect(() => {
        setTaskConnection(getTaskConnection)
    }, [getTaskConnection]);

    useEffect(() => {
        if (batchCode && batchCode.length > 0 && mode === constants.MODE.add) {
            const batchCodeValue = batchCode[0].batchCode.toString()

            const params: ITaskListParams = {
                taskType: "Extract_Task",
                taskCode: batchCodeValue
            };
            dispatch(eventTasks.fetchTaskListReq(params));
        }

    }, [batchCode]);

    // Step 2: Check if there's an existing task connection, if yes then create new task without a connection
    useEffect(() => {
        if (batchCode && batchCode.length > 0 && mode === constants.MODE.add) {
            const batchCodeValue = batchCode[0].batchCode.toString()
            if (taskConnection && taskConnection.length > 0 && taskId.length === 0) {
                // Then, check if there is an existing task connection.
                const taskParams: IPostTaskParams = {
                    layerName: layerName,
                    extractTaskId: null,
                    taskCode: batchCodeValue,
                    taskType: "Extract_Task",
                    owner: email,
                    enabled: true,
                    description: extractorDescription
                };
                dispatch(eventTasks.postTaskRequest(taskParams));
            }
        }
    }, [batchCode, taskConnection, taskId]);

    // Step 3: Check if there is an existing task connection. If not, then create a new task with a new connection
    useEffect(() => {
        if (batchCode && batchCode.length > 0 && mode === constants.MODE.add) {
            const batchCodeValue = batchCode[0].batchCode.toString()
            if (taskConnection && taskConnection.length === 0) {
                const taskParams: IPostTaskParams = {
                    newTaskConnection: {
                        layerName: layerName,
                        description: "Creating a new task connection",
                        criticality: 0
                    },
                    extractTaskId: null,
                    taskCode: batchCodeValue,
                    taskType: "Extract_Task",
                    owner: email,
                    enabled: true,
                    description: extractorDescription
                };
                dispatch(eventTasks.postTaskRequest(taskParams));
            }

        }
    }, [batchCode, taskConnection]);

    // Step 4: Trigger all the jobs and events

    useEffect(() => {
        setTaskValue(getTaskId)
    }, [getTaskId]);

    useEffect(() => {
        if (batchCode && batchCode.length > 0 && mode === constants.MODE.add) {
            const batchCodeValue = batchCode[0].batchCode.toString()

            if (taskValue && taskValue?.taskId) {
                // get triggers that are extractors
                if (eventList.length > 0) {
                    const extractors = eventList.map((ext: any) => {
                        return (
                            ext.extractor[0]
                        )
                    })

                    const eventBased = extractors.map((item: any) => {
                        return {
                            ...item,
                            eventType: "EXTRACT_TASK.SUCCESS",
                            eventAction: "TRIGGER_TASK",
                            scopeType: "EXTRACT_TASK",
                            eventActionValue: taskValue ? taskValue?.taskId : '',
                            eventQualifier: item.newExtractorId ? item.newExtractorId : '', // Note: Set the selected extractor id value here                          
                            enabled: true,
                            description: item.description ? item.description : ''
                        };
                    });

                    eventBased.map((item: any, index: number) => {
                        return dispatch(eventBasedTrigger.postEventTriggersRequest(item));;
                    })
                }

                // get triggers that are loaders
                if (loaderList.length > 0) {
                    const loaders = loaderList.map((loader: any) => {
                        return (
                            loader.loader[0]
                        )
                    })

                    const loaderBased = loaders.map((item: any) => {
                        return {
                            ...item,
                            eventType: "EXTRACT_TASK.SUCCESS",
                            eventAction: "TRIGGER_TASK",
                            scopeType: "LOAD_TASK",
                            eventActionValue: taskValue ? taskValue?.taskId : '',
                            eventQualifier: item.newLoaderId ? item.newLoaderId : '', // Note: Set the selected loader id value here,
                            enabled: true,
                            description: item.description ? item.description : ''
                        };
                    });

                    loaderBased.map((item: any, index: number) => {
                        return dispatch(eventBasedTrigger.postEventTriggersRequest(item));;
                    })
                }

                // get triggers that are inbound webhook based
                if (inboundWebhookList.length > 0) {
                    const inboundBased = inboundWebhookList.map((item: any, index: number) => {
                        return {
                            ...item,
                            eventType: "WEB_HOOK.INBOUND",
                            eventAction: "TRIGGER_TASK",
                            scopeType: "EXTRACT_TASK",
                            taskCode: batchCodeValue,
                            enabled: true,
                            description: item.webhook
                        };
                    });

                    inboundBased.map((item: any, index: number) => {
                        return dispatch(webhookAction.postInboundWebhookRequest(item));
                    })
                }

                // get triggers that are time based
                if (triggerList.length > 0) {
                    const timeBased = triggerList.map((item: any, index: number) => {
                        return {
                            timezone: item.timezone ? item.timezone.replace(" UTC", "") : `${format(new Date(), 'xxx')}`,
                            cronExpression: item.cronExpression,
                            criticality: 0,
                            connectionDescription: endpoint,
                            enabled: true,
                            endpoint: endpoint,
                            extractTaskId: null,
                            owner: email,
                            sourceTargetName: database,
                            scheduleDescription: null,
                            taskCode: batchCodeValue,
                            layerName: layerName,
                            taskType: "Extract_Task",
                            taskDescription: extractorDescription
                        };
                    });
    
                    timeBased.map((item: any, index: number) => {
                        return dispatch(jobScheduleTrigger.postExtJobSchedulesRequest(item));
                    })
                }

                // get outbound webhook actions
                if (actionList.length > 0) {

                    const actionBased = actionList.map((item: any, index: number) => {
                        return {
                            ...item,
                            eventType: "LOAD_TASK.SUCCESS",
                            eventAction: "CALL_WEB_HOOK",
                            scopeType: "LOAD_TASK",
                            eventActionValue: item.outboundWebhook,
                            eventQualifier: taskValue ? taskValue?.taskId : '',
                            enabled: true,
                            description: item.description ? item.description : '',
                            header: item.header ? item.header : ''
                        };
                    });
                    actionBased.map((item: any, index: number) => {
                        return dispatch(webhookAction.postOutboundWebhookRequest(item));;
                    })
                }

            }
        }
    }, [batchCode, taskValue]);

    // 4.2 - This runs after DB extractor executed and a batch code has been received

    // Step 1:  fetch task connection and check if task ID already exists
    useEffect(() => {
        if (dbBatchCode && dbBatchCode.length > 0 && dbBatchCode[0].entityName === entityName && executeTriggers !== null && executeTriggers !== "" && mode === constants.MODE.add) {
            const layerNameParams: ITaskConnectionParams = { layerName: layerName }
            dispatch(eventTasks.fetchTaskConnectionReq(layerNameParams));
        }
    }, [dbBatchCode, executeTriggers]);

    useEffect(() => {
        setTaskConnection(getTaskConnection)
    }, [getTaskConnection]);

    useEffect(() => {
        if (dbBatchCode && dbBatchCode.length > 0 && mode === constants.MODE.add) {
            const batchCodeValue = dbBatchCode[0].batchCode.toString()

            const params: ITaskListParams = {
                taskType: "Extract_Task",
                taskCode: batchCodeValue
            };
            dispatch(eventTasks.fetchTaskListReq(params));
        }

    }, [dbBatchCode]);

    // Step 2:Check if there's an existing task connection, if yes then create new task without a connection
    useEffect(() => {
        if (dbBatchCode && dbBatchCode.length > 0 && dbBatchCode[0].entityName === entityName && executeTriggers !== null && executeTriggers !== "" && mode === constants.MODE.add) {
            const batchCodeValue = dbBatchCode[0].batchCode.toString();
            if (taskConnection && taskConnection.length > 0 && taskId.length === 0) {
                // Then, check if there is an existing task connection.
                const taskParams: IPostTaskParams = {
                    layerName: layerName,
                    extractTaskId: null,
                    taskCode: batchCodeValue,
                    taskType: "Extract_Task",
                    owner: email,
                    enabled: true,
                    description: extractorDescription
                };
                dispatch(eventTasks.postTaskRequest(taskParams));
            }
        }
    }, [dbBatchCode, taskConnection, taskId]);


    // Step 3: Check if there is an existing task connection. If not, then create a new task with a new connection
    useEffect(() => {
        if (dbBatchCode && dbBatchCode.length > 0 && dbBatchCode[0].entityName === entityName && executeTriggers !== null && executeTriggers !== "") {
            const batchCodeValue = dbBatchCode[0].batchCode.toString()
            if (taskConnection && taskConnection.length === 0) {
                const taskParams: IPostTaskParams = {
                    newTaskConnection: {
                        layerName: layerName,
                        description: "Creating a new task connection",
                        criticality: 0
                    },
                    extractTaskId: null,
                    taskCode: batchCodeValue,
                    taskType: "Extract_Task",
                    owner: email,
                    enabled: true,
                    description: extractorDescription
                };
                dispatch(eventTasks.postTaskRequest(taskParams));
            }
        }
    }, [dbBatchCode, taskConnection]);

    // Step 4: Trigger all the jobs and events

    useEffect(() => {
        if (dbBatchCode && dbBatchCode.length > 0 && mode === constants.MODE.add) {
            const batchCodeValue = dbBatchCode[0].batchCode.toString()

            if (taskValue && taskValue?.taskId) {
                // get triggers that are extractors
                if (eventList.length > 0) {
                    const extractors = eventList.map((ext: any) => {
                        return (
                            ext.extractor[0]
                        )
                    })
                    const eventBased = extractors.map((item: any, index: number) => {
                        return {
                            ...item,
                            eventType: "EXTRACT_TASK.SUCCESS",
                            eventAction: "TRIGGER_TASK",
                            scopeType: "EXTRACT_TASK",
                            eventActionValue: taskValue && taskValue?.taskId ? taskValue.taskId : '', // Note: Get Extractor Event Task ID here
                            eventQualifier: item.newExtractorId ? item.newExtractorId : '', // Note: Set the selected extractor id value here
                            enabled: true,
                            description: item.description ? item.description : ''
                        };
                    });
                    eventBased.map((item: any, index: number) => {
                        return dispatch(eventBasedTrigger.postEventTriggersRequest(item));;
                    })
                }

                // get triggers that are loaders
                if (loaderList.length > 0) {
                    const loaders = loaderList.map((loader: any) => {
                        return (
                            loader.loader[0]
                        )
                    })

                    const loaderBased = loaders.map((item: any) => {
                        return {
                            ...item,
                            eventType: "EXTRACT_TASK.SUCCESS",
                            eventAction: "TRIGGER_TASK",
                            scopeType: "LOAD_TASK",
                            eventActionValue: taskValue && taskValue?.taskId ? taskValue.taskId : '', // Note: Get Extractor Event Task ID here
                            eventQualifier: item.newLoaderId ? item.newLoaderId : '', // Note: Set the selected loader id value here,
                            enabled: true,
                            description: item.description ? item.description : ''
                        };
                    });

                    loaderBased.map((item: any, index: number) => {
                        return dispatch(eventBasedTrigger.postEventTriggersRequest(item));;
                    })
                }

                // get triggers that are inbound webhook based
                if (inboundWebhookList.length > 0) {
                    const inboundBased = inboundWebhookList.map((item: any, index: number) => {
                        return {
                            ...item,
                            eventType: "WEB_HOOK.INBOUND",
                            eventAction: "TRIGGER_TASK",
                            scopeType: "LOAD_TASK",
                            taskCode: batchCodeValue,
                            enabled: true,
                            description: item.webhook,
                            // newTask: {
                            //     // layerName: layerName,
                            //     taskCode: batchCodeValue,
                            //     taskType: "WEB_HOOK.INBOUND",
                            //     owner: email,
                            //     enabled: true,
                            //     description: item.webhook,
                            //     extractTaskId: null,
                            //     newTaskConnection: { // creating source for the first time
                            //         layerName: layerName,
                            //         description: item.webhook,
                            //         criticality: 0
                            //     }
                            // }
                        };
                    });

                    inboundBased.map((item: any, index: number) => {
                        return dispatch(webhookAction.postInboundWebhookRequest(item));
                    })
                }

                // get triggers that are time based
                if (triggerList.length > 0) {
                    const timeBased = triggerList.map((item: any, index: number) => {
                        return {
                            timezone: item.timezone ? item.timezone.replace(" UTC", "") : `${format(new Date(), 'xxx')}`,
                            cronExpression: item.cronExpression,
                            criticality: 0,
                            connectionDescription: endpoint,
                            enabled: true,
                            endpoint: endpoint,
                            extractTaskId: null,
                            owner: email,
                            sourceTargetName: database,
                            scheduleDescription: null,
                            taskCode: batchCodeValue,
                            layerName: layerName,
                            taskType: "Extract_Task",
                            taskDescription: extractorDescription
                        };
                    });
    
                    timeBased.map((item: any, index: number) => {
                        return dispatch(jobScheduleTrigger.postExtJobSchedulesRequest(item));
                    })
                }

                // get outbound webhook actions
                if (actionList.length > 0) {

                    const actionBased = actionList.map((item: any, index: number) => {
                        return {
                            ...item,
                            eventType: "EXTRACT_TASK.SUCCESS",
                            eventAction: "CALL_WEB_HOOK",
                            scopeType: "LOAD_TASK",
                            eventActionValue: item.outboundWebhook, // Note: Set the outbound value here,
                            eventQualifier: taskValue && taskValue?.taskId ? taskValue.taskId : '', // Note: Get Extractor Event Task ID here
                            enabled: true,
                            description: item.description ? item.description : '',
                            header: item.header ? item.header : ''
                        };
                    });
                    actionBased.map((item: any, index: number) => {
                        return dispatch(webhookAction.postOutboundWebhookRequest(item));;
                    })
                }

            }
        }
    }, [dbBatchCode, taskValue]);

    function submitTablesData(tablesData: any) {

        // set Trigger chip
        setTriggerCount(tablesData.triggers.length > 0 && (tablesData.triggers[0]?.cronExpression || tablesData.triggers[0]?.extractor ||
            tablesData.triggers[0]?.loader || tablesData.triggers[0]?.webhook !== undefined) ? tablesData.triggers.length : 0)
        setTableDataIndex(tablesData.tableIndex)

        // set Action chip
        setActionCount(tablesData.actions.length > 0 && tablesData.actions[0]?.outboundWebhook ? tablesData.actions.length : 0)

        const hstgKeyCS: string = (tablesData.configureTablesData.customsql.fieldValue !== "" && tablesData.layerType === constants.EXTRACT_TYPES.mssql) ? "CS_" : "";
        const tableKey = `HSTG_${tablesData.layerName.concat("_" + tablesData.configureTablesData.schemaName.fieldValue + "_" + hstgKeyCS + tablesData.getTableName)}_SK`.toUpperCase()
        const hstgKey = {
            "id": "-1",
            "srcColumnName": tableKey,
            "srcDataType": "varchar",
            "srcMaxLength": -1,
            "srcOrdinal": 0,
            "srcPrecision": 0,
            "srcScale": 0,
            "synColumnName": `HSTG_${tablesData.layerName.concat("_" + tablesData.configureTablesData.schemaName.fieldValue + "_" + tablesData.getTableName)}_SK`,
            "synDataType": "VARCHAR",
            "synMaxLength": "100",
            "synOrdinal": "0",
            "synPrecision": "",
            "synScale": "",
            "treatmentLevel": 'low',
            "privacyClassification": "none",
            "securityClassification": "general"
        }
        const a = Object.assign([], tablesData.columnGovernance);
        a.push(hstgKey);

        const s3governanceMetadata = a.map((item: any) => {
            const a = { columnId: item.srcColumnName, "privacyClassification": item.privacyClassification.toLowerCase(), "securityClassification": item.securityClassification.toLowerCase(), "treatmentLevel": item.treatmentLevel.toLowerCase(), "manualTreatment": 's', "ordinal": item.srcOrdinal };
            return a
        });

        const customsqlgovernanceMetadata = a.map((item: any) => {
            const a = { columnId: item.srcColumnName, "privacyClassification": item.privacyClassification.toLowerCase(), "securityClassification": item.securityClassification.toLowerCase(), "treatmentLevel": item.treatmentLevel.toLowerCase(), "manualTreatment": 's', "ordinal": item.srcOrdinal };
            return a
        });

        const governanceMetadata = a.map((item: any) => {
            const a = { columnId: item.srcColumnName, "privacyClassification": item.privacyClassification.toLowerCase(), "securityClassification": item.securityClassification.toLowerCase(), "treatmentLevel": item.treatmentLevel.toLowerCase(), "manualTreatment": 's', "ordinal": item.srcOrdinal };
            return a
        });

       
        // const customTableData = a.map((item: any) => {
        //     const a = { "name": item.synColumnName, "dataType": item.synDataType !== undefined ? item.synDataType.toString() : '', "maxLength": Number(item.synMaxLength), "precision": 0, "scale": 0, "ordinalPosition": item.srcOrdinal };
        //     return a
        // });

        // const s3governance = tablesData.columnGovernance.map((item: any) => {
        //     const a = { columnId: item.srcColumnName, "privacyClassification": item.privacyClassification, "securityClassification": item.securityClassification, "treatmentLevel": item.treatmentLevel, "manualTreatment": 's', "ordinal": item.srcOrdinal };
        //     return a
        // });

        // const customsqlgovernance = tablesData.columnGovernance.map((item: any) => {
        //     const a = { columnId: item.srcColumnName, "privacyClassification": item.privacyClassification, "securityClassification": item.securityClassification, "treatmentLevel": item.treatmentLevel, "manualTreatment": 's', "ordinal": item.srcOrdinal };
        //     return a
        // });

        // extracting fields from columnGovernance for API
        // const governance = tablesData.columnGovernance.map((item: any) => {
        //     const a = { columnId: item.srcColumnName, "privacyClassification": item.privacyClassification, "securityClassification": item.securityClassification, "treatmentLevel": item.treatmentLevel, "manualTreatment": 's', "ordinal": item.srcOrdinal };
        //     return a
        // });

        const customTableData = tablesData.columnGovernance.map((item: any) => {
            const a = { "name": item.synColumnName, "dataType": item.synDataType !== undefined ? item.synDataType.toString() : '', "maxLength": isNaN(parseFloat(item.synMaxLength)) ? 0 : parseFloat(item.synMaxLength), "precision": item.synPrecision ?? 0, "scale": item.synScale ?? 0, "ordinalPosition": item.srcOrdinal };
            return a
        });


      

        const spokeName: string = tablesData.spokeName
        const extlayerName: string = tablesData.layerName
        const layerType: string = tablesData.layerType
        const dbName: string = tablesData.database
        const tableId: string = extlayerName.concat("_" + tablesData.configureTablesData.schemaName.fieldValue + "_" + tablesData.getTableName)
        const getCustomSqltableId: string = extlayerName.concat("_" + tablesData.configureTablesData.schemaName.fieldValue + "_" + "CS" + "_" + tablesData.getTableName)
        const getS3tableId: string = extlayerName.concat("_" + tablesData.configureTablesData.schemaName.fieldValue + "_" + tablesData.getTableName)
        const s3tableId: string = getS3tableId.replaceAll(slash, "_")
        const schemaName: string = tablesData.configureTablesData.schemaName.fieldValue
        const securityClassification: string = tablesData.configureTablesData.securityClassification.fieldValue
        const privacyClassification: string = tablesData.configureTablesData.privacyClassification.fieldValue
        const description: string = tablesData.configureTablesData.description.fieldValue
        setExtractorDescription(tablesData.configureTablesData.description.fieldValue)
        const customsql: string = tablesData.configureTablesData.customsql.fieldValue
        const fileType: string = tablesData.configureTablesData.fileType.fieldValue
        const manifestFileFlag: string = tablesData.configureTablesData.manifestFileFlag.fieldValue
        const blobContainer: string = tablesData.configureTablesData.blobContainer.fieldValue
        const headerRows: string = tablesData.configureTablesData.headerRows.fieldValue
        const fieldDelimeter: string = tablesData.configureTablesData.fieldDelimeter.fieldValue
        const regex: string = tablesData.configureTablesData.regex.fieldValue
        const dataSteward: string = tablesData.dataSteward
        const dataSetName: string = tablesData.connection === "S3 Buckets" ? tablesData.layerName.concat("_" + tablesData.configureTablesData.dataSetName.fieldValue) : tablesData.configureTablesData.dataSetName.fieldValue
        const accessControls: string = tablesData.accessControlGroup
        const manualTreatment: string = ''
        const treatmentLevel: string = ''
        const comparisonKey = tablesData.comparisonKey
        const sourceIDNumber: number = tablesData.sourceID
        const extract: string = tablesData.extract !== "" ? tablesData.extract : '-1'
        const landing: string = tablesData.landing !== "" ? tablesData.landing : '-1'
        const staging: string = "-1"
        const history: string = tablesData.history !== "" ? tablesData.history : '-1'
        const tableName: string = tablesData.getTableName
        setEntityName(tablesData.getTableName)
        // setOwner(email)


        // get extractor info
        const schemaInfo: IEntities[] = [{
            "schema": schemaName,
            "name": tableName,
            "type": 'TABLE',
            "mappingAttribute": comparisonKey.length > 0 ? comparisonKey.join(';') : null
        },
        ]



        // ***********************   STEP 1 - Setup extractor metadata ********************************

        // Setup payload for POST extractor metadata endpoint
        if (tablesData.connection === "S3 Buckets" || tablesData.connection === "Windows Fileshare") {
            let metadataPayload = {
                "tableId": s3tableId,
                "schema": schemaName,
                "layerName": extlayerName,
                "businessMetadata": {
                    "securityClassification": securityClassification,
                    "privacyClassification": privacyClassification,
                    "description": description,
                    "tableName": tablesData.getTableName,
                    "dataStewards": dataSteward,
                    "dataSetName": dataSetName,
                    "accessControls": accessControls,
                    "manualTreatment": manualTreatment,
                    "treatmentLevel": treatmentLevel,
                },
                "columnGovernanceMetadata": s3governanceMetadata // updated metadata with SK field
            }
            dispatch(actions.postMetaDataExtractorRequest(metadataPayload));
        }
        else {
            let adlsTableId = "";
            if (tablesData.layerType === constants.EXTRACT_TYPES.adls) {
                adlsTableId = extlayerName.concat("_" + `${tablesData.layerName}_landing_${schemaName}` + "_" + tablesData.getTableName);
            }
            let metadataPayload = {
                "tableId": customsql !== "" ? getCustomSqltableId : tablesData.layerType !== constants.EXTRACT_TYPES.adls ? tableId : adlsTableId,
                "schema": tablesData.connection === constants.CONNECTION_TYPES.azure ? `${tablesData.layerName}/landing/${schemaName}` : schemaName,
                "layerName": extlayerName,
                "businessMetadata": {
                    "securityClassification": securityClassification,
                    "privacyClassification": privacyClassification,
                    "description": description,
                    "tableName": tablesData.getTableName,
                    "dataStewards": dataSteward,
                    "dataSetName": dataSetName,
                    "accessControls": accessControls,
                    "manualTreatment": manualTreatment,
                    "treatmentLevel": treatmentLevel,
                },
                "columnGovernanceMetadata": customsql !== "" ? customsqlgovernanceMetadata : governanceMetadata
            }
            dispatch(actions.postMetaDataExtractorRequest(metadataPayload));

        }

        // ***********************   STEP 2 - Setup extractor ********************************

        // Setup payload for DB extractor endpoint

        if ((tablesData.connection !== "S3 Buckets" && tablesData.connection !== "Windows Fileshare" && tablesData.connection !== constants.CONNECTION_TYPES.azure && tablesData.connection !== constants.CONNECTION_TYPES.foundry) && customsql === "") {
            let dbExtractorPayload = {
                "sourceId": sourceIDNumber,
                "platformGroup": spokeName !=="HUB" ? spokeName : "HUB",
                "userEmail": email,
                "extPattern": {
                    "selectedPatternId": extract,
                    "insertDateTime": tablesData.layerType === "EXTRACT_ORACLE" ? "TO_CHAR(SYS_EXTRACT_UTC(SYSTIMESTAMP),'YYYY-MM-DD HH24:MI:SS.FF')" : "format(SYSUTCDATETIME(),'yyyy-MM-dd HH:mm:ss.ffffff')",
                    "businessDateTime": tablesData.layerType === "EXTRACT_ORACLE" ? "" : "getdate()"
                },
                "lndPattern": {
                    "selectedPatternId": landing,
                },
                "stgPattern": {
                    "selectedPatternId": staging,
                },
                "hstgPattern": {
                    "selectedPatternId": history,
                },
                "entities": schemaInfo
            }
            dispatch(dbExtractor.postDBExtRequest(dbExtractorPayload));

        }

        // if custom sql then call the custom extractor endpoint
        if ((tablesData.connection !== constants.CONNECTION_TYPES.s3Buckets || tablesData.connection !== constants.CONNECTION_TYPES.windowsFileshare || tablesData.connection !== constants.CONNECTION_TYPES.azure || tablesData !== constants.CONNECTION_TYPES.foundry) && customsql !== "") {
            let customExtractorPayload = {
                "sourceId": sourceIDNumber,
                "platformGroup": spokeName !=="HUB" ? spokeName : "HUB",
                "userEmail": email,
                "extPattern": {
                    "selectedPatternId": extract,
                    "insertDateTime": tablesData.layerType === "EXTRACT_ORACLE" ? "TO_CHAR(SYS_EXTRACT_UTC(SYSTIMESTAMP),'YYYY-MM-DD HH24:MI:SS.FF')" : "format(SYSUTCDATETIME(),'yyyy-MM-dd HH:mm:ss.ffffff')",
                    "businessDateTime": tablesData.layerType === "EXTRACT_ORACLE" ? "" : "getdate()"
                },
                "lndPattern": {
                    "selectedPatternId": landing
                },
                "stgPattern": {
                    "selectedPatternId": staging
                },
                "hstgPattern": {
                    "selectedPatternId": history
                },
                "entities": [
                    {
                        "schema": schemaName,
                        "name": tableName,
                        "type": 'TABLE',
                        "mappingAttribute": comparisonKey.length > 0 ? comparisonKey.join(';') : null,
                        "customSql": customsql,
                        "columns": customTableData,
                        "fileRegistration": null
                    }
                ]
            }
            dispatch(dbExtractor.postCustomExtRequest(customExtractorPayload));
        }


        // If S3,WFS,ADLS,Foundry then setup payload for custom extractor endpoint
        if (tablesData.connection === constants.CONNECTION_TYPES.s3Buckets || tablesData.connection === constants.CONNECTION_TYPES.windowsFileshare || tablesData.connection === constants.CONNECTION_TYPES.azure || tablesData.connection === constants.CONNECTION_TYPES.foundry) {
            var isHeader = false;
            var delimeter = ",";
            if (connection === constants.CONNECTION_TYPES.azure || connection === constants.CONNECTION_TYPES.s3Buckets) {
                if (headerRows === "" || headerRows !== "FALSE") {
                    isHeader = true;
                }

                if (fieldDelimeter !== "") {
                    delimeter = fieldDelimeter;
                }
            }

            let customExtractorPayload = {
                "sourceId": sourceIDNumber,
                "platformGroup": spokeName !=="HUB" ? spokeName : "HUB",
                "userEmail": email,
                "extPattern": {
                    "selectedPatternId": extract,
                    "insertDateTime": "format(SYSUTCDATETIME(),'yyyy-MM-dd HH:mm:ss.ffffff')",
                    "businessDateTime": "getdate()"
                },
                "lndPattern": {
                    "selectedPatternId": landing
                },
                "stgPattern": {
                    "selectedPatternId": staging
                },
                "hstgPattern": {
                    "selectedPatternId": history
                },
                "entities": [
                    {
                        "schema": tablesData.connection === constants.CONNECTION_TYPES.azure ? `${tablesData.layerName}/landing/${schemaName}` : schemaName,
                        "name": tablesData.getTableName,
                        "type": "FF",
                        "mappingAttribute": comparisonKey.length > 0 ? comparisonKey.join(';') : null,
                        "customSql": customsql,
                        "columns": customTableData,
                        "fileRegistration": {
                            "blobContainer": blobContainer,
                            "fieldDelimeter": delimeter,
                            "extension": tablesData.connection === constants.CONNECTION_TYPES.azure ? "csv" : fileType,
                            "isHeader": isHeader,
                            "manifestFileFlag": manifestFileFlag,
                            "wildcardExpression": regex,
                            "fileName": dataSetName,
                            "folderName": tablesData.connection === constants.CONNECTION_TYPES.azure ? `${tablesData.layerName}/landing/${schemaName}` : schemaName,
                            "deleteFlag": tablesData.configureTablesData.deleteFiles.fieldValue,
                            "textDelimiter": tablesData.configureTablesData.textDelimiter.fieldValue,
                            "escapeChar": tablesData.configureTablesData.escapeChar.fieldValue
                        }
                    }
                ]
            }
            dispatch(dbExtractor.postCustomExtRequest(customExtractorPayload));
        }


        // ***********************   STEP 3 - Get Batch Code and execute triggers and actions ********************************

        // Filter out triggers and then pass it to state individually 

        // get only time based triggers
        const triggers = tablesData.triggers.filter((itm: any) => itm.cronExpression)
        setTriggerList(triggers)

        // get only extractor based triggers
        const eventTrigger = tablesData.triggers.filter((itm: any) => itm.extractor)
        setEventList(eventTrigger)

        // get only loader based triggers
        const loaderTrigger = tablesData.triggers.filter((itm: any) => itm.loader)
        setLoaderList(loaderTrigger)

        // get only inbound webhook based triggers
        const inboundTrigger = tablesData.triggers.filter((itm: any) => itm.webhook)
        setInboundWebhookList(inboundTrigger)

        // get only outbound action
        const outboundAction = tablesData.actions.filter((itm: any) => itm.outboundWebhook)
        setActionList(outboundAction)

        // set database and layer name received to state
        setDatabase(dbName)
        setLayerName(extlayerName)
        setExecuteTriggers("Execute Triggers")
        // ***********************   STEP 0 - Alert user that table data has been submitted ********************************
        alert("Table Data Submitted")
        
    }

    const [expanded, setExpanded] = useState<Number | false>(0);

    const handleChange = (panel: Number) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <div>
            <h1>Create Extractors</h1>
            {/* passing selected tables data into the accordion */}
            {selectedTables && selectedTables.map((item: any, index: any) => {
                return (
                    <Accordion key={index} expanded={expanded === index} onChange={handleChange(index)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography sx={{ width: '70%', flexShrink: 0, fontWeight: '600' }}>  {item}</Typography>
                            <Typography sx={{ width: '10%', color: 'text.secondary', }}> {tableDataIndex === index ? actionCount > 0 ? <Chip label={`Actions: ${actionCount}`} /> : '' : ''}</Typography>
                            <Typography sx={{ width: '10%', color: 'text.secondary', }}>  {tableDataIndex === index ? triggerCount > 0 ? <Chip label={`Triggers: ${triggerCount}`} /> : '' : ''}</Typography>
                            <Typography sx={{ width: '10%', color: 'text.secondary', }}>
                                {errorList && Object.keys(errorList).length > 0 ? (
                                    errorList[item] !== undefined ? (
                                        errorList[item].error ? (
                                            <ErrorIcon color="error" />
                                        ) : ""
                                    ) : ""
                                ) : ""}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                <ConfigureTablesForm tableName={item} customSQL={customSQL} tableIndex={index} setErrorList={setErrorList} submitTablesData={submitTablesData}
                                dataSourceData={dataSourceData} accessControlGroup={accessControlGroup} dataStewardGroup={dataStewardGroup} dataStewardIDs={dataStewardIDs} 
                                    selectedSchemas={selectedSchema} connection={connection} sourceID={sourceID} dataSourceName={dataSourceName} spokeName={spokeName} endpoint={endpoint} mode="Add" />
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                )
            })}

        </div>
    )
}
export default CreateExtractorComponent